import { Link, Text, View } from '@react-pdf/renderer'
import Html from 'react-pdf-html'

import { OrderModalValues } from '@/types'

import { htmlPdfStyles, styles } from '../pdfStyles'

export const Footer = ({
  label,
  currentPage,
  totalPages,
  order,
  showSignAndConditions,
}: {
  label?: string
  currentPage?: number
  totalPages?: number
  order?: OrderModalValues
  showSignAndConditions?: boolean
}) => {
  const showBankInformation =
    showSignAndConditions &&
    order?.orderParameters?.showOnInvoices &&
    (order?.orderParameters?.establishment ||
      order?.orderParameters?.bic ||
      order?.orderParameters?.iban ||
      order?.orderParameters?.conditions)

  const metadata = Array.isArray(order?.metadata)
    ? (order?.metadata?.find((item) => item.key === 'ORDERPARAMETERS')
        ?.value as {
        showOnInvoices?: boolean
        establishment?: string
        bic?: string
        iban?: string
        conditions?: string
      } | null)
    : null

  const showBankInformationWithMetadata =
    metadata?.showOnInvoices &&
    order?.type === 'CART' &&
    (metadata?.establishment ||
      metadata?.bic ||
      metadata?.iban ||
      metadata?.conditions)

  return (
    <View>
      {!!(showSignAndConditions && order?.type !== 'FAVORITE') && (
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: 180,
            overflow: 'hidden',
          }}
        >
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '50%',
              gap: 4,
            }}
          >
            {!!(showBankInformation || showBankInformationWithMetadata) && (
              <View>
                {!!order?.orderBonusFieldThree && (
                  <View style={{ marginBottom: 6 }}>
                    <Text
                      style={{
                        ...styles.bold,
                        fontSize: 8,
                      }}
                    >
                      {order?.orderBonusFieldThree}
                    </Text>
                  </View>
                )}
                <View
                  style={{
                    padding: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    borderRadius: 4,
                    backgroundColor: '#F3F3F4',
                  }}
                >
                  {!!(
                    order?.orderParameters?.establishment ||
                    metadata?.establishment
                  ) && (
                    <Text>
                      <Text style={styles.bold}>Établissement: </Text>
                      {order?.orderParameters?.establishment ||
                        metadata?.establishment}
                    </Text>
                  )}
                  {!!(order?.orderParameters?.bic || metadata?.bic) && (
                    <Text>
                      <Text style={styles.bold}>BIC: </Text>
                      {order?.orderParameters?.bic || metadata?.bic}
                    </Text>
                  )}
                  {!!(order?.orderParameters?.iban || metadata?.iban) && (
                    <Text>
                      <Text style={styles.bold}>IBAN: </Text>
                      {order?.orderParameters?.iban || metadata?.iban}
                    </Text>
                  )}
                </View>
                {!!(
                  order?.orderParameters?.conditions || metadata?.conditions
                ) && (
                  <Html stylesheet={htmlPdfStyles}>
                    {`<p>${order?.orderParameters?.conditions || metadata?.conditions}</p>`}
                  </Html>
                )}
              </View>
            )}
          </View>
          {order?.requestType === 'quote' &&
            !order?.orderParameters?.hideSignInputs && (
              <View
                style={{
                  width: '50%',
                }}
              >
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 30,
                    marginLeft: 55,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: 'Helvetica',
                    }}
                  >
                    Fait à
                  </Text>
                  <Text
                    style={{
                      fontSize: 10,
                      marginTop: 10,
                      marginBottom: 12,
                      fontFamily: 'Helvetica',
                    }}
                  >
                    le
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      marginBottom: 12,
                      fontFamily: 'Helvetica-Bold',
                    }}
                  >
                    {order?.name}
                  </Text>
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: 'Helvetica',
                      marginBottom: 12,
                    }}
                  >
                    Signature :
                  </Text>
                </View>
              </View>
            )}
        </View>
      )}
      <View style={styles.line} />
      <View
        style={{
          marginTop: 4,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Text style={{ fontSize: 8 }}>
          {new Date().getFullYear()}, {label}
          <Link href="https://www.skop.app/" style={styles.link}>
            {' '}
            Skop
          </Link>
        </Text>
        {!!currentPage && (
          <Text style={{ fontSize: 8 }}>
            page {currentPage} {!!totalPages && `sur ${totalPages}`}
          </Text>
        )}
      </View>
    </View>
  )
}
